import { memo, useEffect, useMemo } from 'react';
import { BzChip } from '../../components';
import { Container, Row, Col } from 'react-bootstrap';
import { OPTION_CHAIN, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { handleModal } from "../../redux/actions/modals";
import { useDispatch, useSelector, } from 'react-redux';
import { openOptionChain } from '../../redux/actions/optionChain';
import { getDistinctExpiry } from '../../apis';



const TabOptionsContent = ({ setShow, arrOPScrips, tab, strSearchActiveTab, handleOnClickScrip, onBuySellClick, scripDetails, removeScrips, addScrips, nActiveCard, activeButton, onKeyDown = () => { }, availableOptions, setAvailableOptions = () => { }, ...props }) => { //BT-113516 Adding /Removing scrips through inline search in watchlist : Manasa B : 17/07/2023 

    const dispatch = useDispatch();

    const arrGlobalSearchFutOptions = useSelector(state => state.optionChain.arrGlobalSearchFutOptions);
    /*Ameersha N -- BREEZE -- BT-109096 -- OPTION CHAIN GLOABL SEARCH --start*/
    const handleOptionChain = async (e, i, each) => {
        let date = e.key?.toUpperCase()?.trim(" ");
        let symbol = each?.key?.symbol?.toUpperCase()?.trim(" ");
        let exchange = each?.key?.exchange?.toUpperCase()?.trim(" ");
        //Ameersha N- 25-07-2025 - As option tab contents doestn have any data related scrips we are storing fut scrips and searching for selected scrip
        let nIndex = arrGlobalSearchFutOptions?.findIndex(eachScrip => eachScrip[WATCHLIST_GRID_INDEX.SYMBOL] === symbol && eachScrip[WATCHLIST_GRID_INDEX?.EXCHANGE] === exchange && eachScrip[WATCHLIST_GRID_INDEX.EXPIRYDATE] === date);
        if (nIndex >= 0) {
            let selectedScrip = arrGlobalSearchFutOptions[nIndex];
            const arrDistinctDates = each.optexp.buckets.map((item) => item.key.toString().toUpperCase());
            setShow(false);
            /*Ameersha N -- BREEZE -- BT-109096 -- OPTION CHAIN GLOABL SEARCH --start*/
            dispatch(openOptionChain({
                id: selectedScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                mappedId: selectedScrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                token: selectedScrip[WATCHLIST_GRID_INDEX.TOKEN],
                assetToken: selectedScrip[WATCHLIST_GRID_INDEX.ASSET_TOKEN],
                instrument: selectedScrip[WATCHLIST_GRID_INDEX.INSTRUMENT],
                instrumentName: selectedScrip[WATCHLIST_GRID_INDEX.INSTRUMENT],
                symbol: each?.key?.symbol?.toUpperCase(),
                expiryDate: e?.key?.toUpperCase(),
                location: OPTION_CHAIN.GLOBAL_SEARCH,
                distinctDates: arrDistinctDates,
                dateArr: arrDistinctDates,
                exchange: each?.key?.exchange?.toUpperCase()
            }));
            /*Ameersha N -- BREEZE -- BT-109096 -- OPTION CHAIN GLOABL SEARCH --End*/
            dispatch(handleModal([{ 'OPTION_CHAIN': true }]));
        } else {
            let objResp = await getDistinctExpiry(symbol);
            const respData = objResp?.data?.result?.hits?.hits;
            let aIndex = respData?.findIndex(eachScrip => eachScrip?._source?.sSymbolnew === symbol && eachScrip?._source?.sExchange === exchange && eachScrip?._source?.nExpiryDate1 === date);
            if (aIndex >= 0) {
                let selectedScrip = respData[aIndex];
                const arrDistinctDates = each.optexp.buckets.map((item) => item.key.toString().toUpperCase());
                setShow(false);

                /*Ameersha N -- BREEZE -- BT-109096 -- OPTION CHAIN GLOABL SEARCH --start*/
                dispatch(openOptionChain({
                    id: selectedScrip?._source?.nMarketSegmentId,
                    mappedId: selectedScrip?._source?.nMarketSegmentId,
                    token: selectedScrip?._source?.nToken,
                    assetToken: selectedScrip?._source?.nAssetToken,
                    instrument: selectedScrip?._source?.sInstrumentName,
                    instrumentName: selectedScrip?._source?.sInstrumentName,
                    symbol: each?.key?.symbol?.toUpperCase(),
                    expiryDate: e?.key?.toUpperCase(),
                    location: OPTION_CHAIN.GLOBAL_SEARCH,
                    distinctDates: arrDistinctDates,
                    dateArr: arrDistinctDates,
                    exchange: each?.key?.exchange?.toUpperCase()
                }));
                /*Ameersha N -- BREEZE -- BT-109096 -- OPTION CHAIN GLOABL SEARCH --End*/
                dispatch(handleModal([{ 'OPTION_CHAIN': true }]));
            } else {
                //Ameersha N we have not found data we just open option chain thats all
                let dates = each?.optexp?.buckets?.map(eachScrip => eachScrip?.key?.toUpperCase());
                dispatch(openOptionChain({
                    id: arrGlobalSearchFutOptions[0][WATCHLIST_GRID_INDEX.SEGMENT_ID],
                    mappedId: '',
                    token: '',
                    assetToken: "",
                    instrument: "",
                    instrumentName: "",
                    symbol: each?.key?.symbol?.toUpperCase(),
                    expiryDate: e?.key?.toUpperCase(),
                    location: OPTION_CHAIN.GLOBAL_SEARCH,
                    distinctDates: dates,
                    dateArr: dates,
                    exchange: each?.key?.exchange?.toUpperCase()
                }));

                dispatch(handleModal([{ 'OPTION_CHAIN': true }]));
            }
        }

        setShow(false);
    };
    /*Ameersha N -- BREEZE -- BT-109096 -- OPTION CHAIN GLOABL SEARCH --End*/



    const dateSortedData = useMemo(() => {
        let data = arrOPScrips;
        data?.forEach(item => {
            item?.optexp?.buckets?.sort((a, b) => new Date(a?.key) - new Date(b?.key));
        });
        return data;
    }, [arrOPScrips]);
    // Ameersha N : 14-12-2023 : BT-96728 Global Search feature - issue - sorting adn arranging contracts date accordingly -End
    useEffect(() => {
        if (tab === strSearchActiveTab) {
            setAvailableOptions(dateSortedData[nActiveCard]?.optexp?.buckets.map(x => x.key));
        }
    }, [nActiveCard, dateSortedData, tab, strSearchActiveTab]);
    useEffect(() => {
        document.addEventListener('keyup', onKeyDown);
        return () => {
            document.removeEventListener('keyup', onKeyDown);
        };
    }, [activeButton, onKeyDown]);
    return (
        <>
            {dateSortedData.length > 0 &&
                <Container className='p-0'>
                    {
                        dateSortedData.map((each, index) =>
                            <Row style={{ border: nActiveCard === index ? '' : null }} onKeyDown={onKeyDown} tabindex={nActiveCard === index ? 0 : -1} id={'globalsearchCard' + strSearchActiveTab + index} className={`g-0 ${nActiveCard === index ? 'global-search-focus': ''} ${scripDetails?.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) ? 'watchlist-active-scrip' : ''} px-3 py-4`} key={index}>
                                <Col md={12} className='d-flex justify-content-start align-items-center' key={index}>
                                    <Container fluid className='p-0'>
                                        <Row className='g-0'>
                                            <Col className='d-flex justify-content-start align-items-center'>
                                                <div className='font-medium font-size4 color-text cursor-pointer text-uppercase text-nowrap me-2'>{each?.key?.symbol}</div>
                                                <div className='chips-wrap'>
                                                    <BzChip className='exchange-chip text-uppercase me-2'>{each?.key?.exchange}</BzChip>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mt-1'>
                                            <Col className='d-flex justify-content-start'>
                                                <div className='font-regular font-size3 color-subtext cursor-pointer text-uppercase'>{each?.key?.desc}</div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 mt-2'>
                                            <Col className='d-flex justify-content-start'>
                                                <div className='recooptions-card-wrap'>
                                                    {each?.optexp?.buckets?.length > 0 && each?.optexp?.buckets?.map((eachExp, i) => {
                                                        return (
                                                            <div className={`${nActiveCard === index && activeButton === eachExp.key ? 'global-search-icon-focus' : ''} recooptions-card`} tabindex={nActiveCard === index ? 0 : -1} id={eachExp.key} onClick={handleOptionChain.bind(this, eachExp, i, each)} key={i}>
                                                                <Row className='g-0'>
                                                                    <Col className='d-flex justify-content-start'>
                                                                        <div className='font-medium font-size4 color-text cursor-pointer text-uppercase'>{eachExp.key}</div>
                                                                    </Col>
                                                                </Row>
                                                                <Row className='g-0 mt-1'>
                                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                                        <div className='font-medium font-size1 color-textual-link-withicon'>Option Chain</div>
                                                                        <div className='icon-12 icon-arrowdown background-textual-link-withicon ms-2'></div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className='g-0 pt-3'>
                                            <Col className='d-flex justify-content-start'>
                                                <div className='font-regular font-size1 color-subtext'>*{each?.optexp?.buckets?.length} Expiries avaialble till {each?.maxDate}</div>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Col>
                            </Row>
                        )
                    }
                </Container>}
        </>
    );
};

export default memo(TabOptionsContent);